import { render, staticRenderFns } from "./user-editing.vue?vue&type=template&id=54807814&scoped=true&"
import script from "./user-editing.vue?vue&type=script&lang=js&"
export * from "./user-editing.vue?vue&type=script&lang=js&"
import style0 from "./user-editing.vue?vue&type=style&index=0&id=54807814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54807814",
  null
  
)

export default component.exports